<script>
export default {
    
}
</script>

<template>
    <footer>
        <p class="footer-text">フッター</p>
    </footer>
</template>

<style scoped>
    footer{
        padding: 30px 10%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color:#3a4a5e;
    }
    .footer-text{
        text-align: center;
        font-size: 2.4rem;
        color: white;
    }
</style>

